<app-menu>
    <div id="container">
        <div id="content">
            <div class="header">
                <h1>Create Rates</h1>
            </div>
            <div>
                <form [formGroup]="rates_form">
                    <div >
                        <mat-label>Rate Type:</mat-label>
                        <mat-radio-group formControlName="rate_type" class="form-item">
                            <mat-radio-button  *ngFor="let item of rate_type_options | keyvalue" [value]="item.key">{{item.value}}</mat-radio-button>
                        </mat-radio-group>
                    </div>
                    <div *ngIf="rates_form.get('rate_type')?.value == 'cubic_weight'" >
                        <mat-label>Range (in lbs):</mat-label>
                        <mat-radio-group formControlName="cubic_range" *ngFor="let item of cubic_range_options" class="form-item">
                            <mat-radio-button [value]="item">{{item}}</mat-radio-button>
                        </mat-radio-group>
                    </div>
                    <div>
                        <mat-radio-group formControlName="LTL_FTL" class="form-item">
                            <mat-radio-button value="">None</mat-radio-button>
                            <mat-radio-button value="LTL">LTL</mat-radio-button>
                            <mat-radio-button value="FTL">FTL</mat-radio-button>
                        </mat-radio-group>
                    </div>
                    <div class="multiple-form-fields-row">
                        <mat-form-field>
                            <mat-label>Effective Start Date</mat-label>
                            <input matInput [matDatepicker]="start_date" formControlName="start_date"/>
                            <mat-datepicker-toggle matIconSuffix [for]="start_date"></mat-datepicker-toggle>
                            <mat-datepicker #start_date>
                                <mat-datepicker-actions>
                                    <button mat-button matDatepickerCancel>Cancel</button>
                                    <button mat-raised-button color="primary" matDatepickerApply>Confirm</button>
                                </mat-datepicker-actions>              
                            </mat-datepicker>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Effective End Date</mat-label>
                            <input matInput [matDatepicker]="end_date" formControlName="end_date"/>
                            <mat-datepicker-toggle matIconSuffix [for]="end_date"></mat-datepicker-toggle>
                            <mat-datepicker #end_date>
                                <mat-datepicker-actions>
                                    <button mat-button matDatepickerCancel>Cancel</button>
                                    <button mat-raised-button color="primary" matDatepickerApply>Confirm</button>
                                </mat-datepicker-actions>              
                            </mat-datepicker>
                        </mat-form-field>
                    </div>
                </form>
            </div>
        </div>
    </div>
</app-menu>